import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: theme.spacing(2)
    },
    alert: {
        marginBottom: theme.spacing(1)
    },
    gridTitle: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        color: 'white'
    }
}));

export default useStyles;
